@let errorsFrom =
  {
    pattern: 'transfer.form.amount.validator.pattern' | translate,
    maxDecimals:
      'transfer.form.amount.validator.maxDecimals'
      | translate
        : {
            max: getWalletById(form().value.walletFromId)?.coin.decimals,
          },
  };

@let errorsTo =
  {
    pattern: 'transfer.form.amount.validator.pattern' | translate,
    maxDecimals:
      'transfer.form.amount.validator.maxDecimals'
      | translate
        : {
            max: getWalletById(form().value.walletToId)?.coin.decimals,
          },
  };

<form class="kr-exchange__form" [formGroup]="form()">
  <div class="kr-exchange__row">
    <div class="kr-exchange__col">
      <kr-search-select
        class="fr-width-100"
        [control]="form().controls.walletFromId"
        data-testid="exchange_crypto_crypto_wallet_from_id"
        [items]="wallets()"
        [withSearch]="true"
        [multi]="false"
        [label]="'exchange.dialog.fromWallet' | translate"
        [placeholder]="'exchange.dialog.notSelected' | translate"
        [height]="60">
        <ng-template #itemTpl let-wallet>
          <kr-wallet-item
            [attr.data-testid]="
              'exchange_crypto_crypto_wallet_from' + wallet.name
            "
            [wallet]="wallet" />
        </ng-template>
      </kr-search-select>
      <fu-simple-input
        class="fr-width-100"
        [formControl]="form().controls.amount"
        data-testid="exchange_crypto_crypto_amount"
        [isReadonly]="!!form().controls.amountTo.value"
        [errorDictionary]="errorsFrom"
        [iconTemplate]="coinFrom"
        [label]="'exchange.dialog.amount' | translate"
        [placeholder]="'exchange.dialog.amount' | translate" />
    </div>
    <fu-icon
      class="kr-exchange__icon-arrow"
      iconName="arrow-right-filled"
      size="48">
    </fu-icon>
    <div class="kr-exchange__col">
      <kr-search-select
        class="fr-width-100"
        [control]="form().controls.walletToId"
        data-testid="exchange_crypto_crypto_wallet_to_id"
        [items]="walletsReceive()"
        [placeholder]="'exchange.dialog.notSelected' | translate"
        [withSearch]="true"
        [multi]="false"
        [label]="'exchange.dialog.toWallet' | translate"
        [height]="60">
        <ng-template #itemTpl let-wallet>
          <kr-wallet-item
            [attr.data-testid]="
              'exchange_crypto_crypto_wallet_to' + wallet.name
            "
            [wallet]="wallet" />
        </ng-template>
      </kr-search-select>
      <fu-simple-input
        class="fr-width-100"
        data-testid="exchange_crypto_crypto_amount_to"
        [formControl]="form().controls.amountTo"
        [isReadonly]="!!form().controls.amount.value"
        [errorDictionary]="errorsTo"
        [label]="'exchange.dialog.amountToReceive' | translate"
        [placeholder]="'exchange.dialog.amountToReceive' | translate"
        [iconTemplate]="coinTo" />
    </div>
  </div>
</form>

<ng-template #coinFrom>
  <div
    class="kr-exchange__coin-icon"
    data-testid="exchange_crypto_crypto_coin_from">
    {{ getWalletById(form().controls.walletFromId.value)?.coin.symbol }}
  </div>
</ng-template>

<ng-template #coinTo>
  <div
    class="kr-exchange__coin-icon"
    data-testid="exchange_crypto_crypto_coin_to">
    {{ getWalletById(form().controls.walletToId.value)?.coin.symbol }}
  </div>
</ng-template>
